import { SizableText, Button, Container, XStack, YStack } from '@my/ui'
import { Check, Copy, CopyCheck } from '@tamagui/lucide-icons'
import openLink from './lib/handle-link'
import { copyToClipboard } from 'app/lib/copy-to-clipboard'
import { useCallback, useState } from 'react'

export type OfferLinkProps = {
  code?: string
  validUntil?: string
  link: string
}

export const OfferLink = (props: OfferLinkProps) => {
  const [isCopied, setIsCopied] = useState(false)

  const handleButtonPress = useCallback(async () => {
    if (props.code) {
      await copyToClipboard(props.code)
      setIsCopied(true)
      setTimeout(() => setIsCopied(false), 4000)
    }

    openLink(props.link)
  }, [props.code, props.link])

  const handleCopyUrl = useCallback(async () => {
    await copyToClipboard(props.link)
    setIsCopied(true)
    setTimeout(() => setIsCopied(false), 4000)
  }, [props.code])

  return (
    <Container>
      <YStack gap="$3" ai="center">
        {props.code && (
          <XStack
            width="100%"
            backgroundColor="$primary3"
            alignItems="center"
            justifyContent="center"
            py="$2.5"
            borderRadius={4}
            borderStyle="dashed"
            borderColor="$primary12"
            borderWidth={1}
          >
            <SizableText size="$5" fow="500">
              {props.code}
            </SizableText>
          </XStack>
        )}
        {props.validUntil && (
          <XStack gap="$2" ai="center">
            <Check size={24} />
            <SizableText size="$2" fow="500">
              This is a single use code and will expire at {[
                new Date(props.validUntil).toLocaleTimeString(),
                new Date(props.validUntil).toLocaleDateString(),
              ].join(' on ')}
            </SizableText>
          </XStack>
        )}

        <Button
          fontSize="$4"
          fontWeight="500"
          theme="black"
          onPress={handleButtonPress}
          width="100%"
        >
          {props.code ? 'Copy Code & Use Now' : 'Visit Website'}
        </Button>

        <XStack gap="$2" ai="center" onPress={handleCopyUrl} cursor="pointer">
          {isCopied ? <CopyCheck size={24} /> : <Copy size={24} />}

          <SizableText size="$2" fow="500">
            {isCopied ? 'Copied URL' : 'Copy URL'}
          </SizableText>
        </XStack>
      </YStack>
    </Container>
  )
}
